import { ReactComponent as LogoIcon } from "static/svg/logo_white.svg"
import { SvgIcon } from "@mui/material"

const Logo = (props) => <SvgIcon component={LogoIcon} inheritViewBox {...props} />

export default Logo
